import { ReactNode } from 'react';
import { DataGridHandler } from './DataGridHandler';
import { DataGridAlerts } from './alerts';
import DataGridFlexSalesProvider from './DataGridFlexSalesProvider';
import DataGrid from './DataGrid';

interface DataGridFlexSalesProps<TData, TContext> {
  handlerFactory: (locale: Locale) => DataGridHandler<TData, TContext>;
  children: ReactNode;
}

const DataGridFlexSales = <TData, TContext>({
  handlerFactory,
  children,
}: DataGridFlexSalesProps<TData, TContext>) => (
  <DataGridFlexSalesProvider handlerFactory={handlerFactory}>
    {children}
    <DataGridAlerts />
    <DataGrid />
  </DataGridFlexSalesProvider>
);
export default DataGridFlexSales;
